"use strict";

var _regeneratorRuntime = require("/Users/ted/projects/ZiktoInsuranceWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/ted/projects/ZiktoInsuranceWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/ted/projects/ZiktoInsuranceWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ted/projects/ZiktoInsuranceWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var axios_1 = __importDefault(require("axios"));

var errors_1 = require("./errors");

var instrument_1 = require("./instrument");
/**
 * A client for Slack's Incoming Webhooks
 */


var IncomingWebhook = /*#__PURE__*/function () {
  function IncomingWebhook(url) {
    var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, IncomingWebhook);

    if (url === undefined) {
      throw new Error('Incoming webhook URL is required');
    }

    this.url = url;
    this.defaults = defaults;
    this.axios = axios_1.default.create({
      baseURL: url,
      httpAgent: defaults.agent,
      httpsAgent: defaults.agent,
      maxRedirects: 0,
      proxy: false,
      headers: {
        'User-Agent': instrument_1.getUserAgent()
      }
    });
    delete this.defaults.agent;
  }
  /**
   * Send a notification to a conversation
   * @param message - the message (a simple string, or an object describing the message)
   */


  _createClass(IncomingWebhook, [{
    key: "send",
    value: function () {
      var _send = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(message) {
        var payload, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // NOTE: no support for TLS config
                payload = Object.assign({}, this.defaults);

                if (typeof message === 'string') {
                  payload.text = message;
                } else {
                  payload = Object.assign(payload, message);
                }

                _context.prev = 2;
                _context.next = 5;
                return this.axios.post(this.url, payload);

              case 5:
                response = _context.sent;
                return _context.abrupt("return", this.buildResult(response));

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](2);

                if (!(_context.t0.response !== undefined)) {
                  _context.next = 15;
                  break;
                }

                throw errors_1.httpErrorWithOriginal(_context.t0);

              case 15:
                if (!(_context.t0.request !== undefined)) {
                  _context.next = 19;
                  break;
                }

                throw errors_1.requestErrorWithOriginal(_context.t0);

              case 19:
                throw _context.t0;

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 9]]);
      }));

      function send(_x) {
        return _send.apply(this, arguments);
      }

      return send;
    }()
    /**
     * Processes an HTTP response into an IncomingWebhookResult.
     */

  }, {
    key: "buildResult",
    value: function buildResult(response) {
      return {
        text: response.data
      };
    }
  }]);

  return IncomingWebhook;
}();

exports.IncomingWebhook = IncomingWebhook;